export class PermissionBase {
    can_view: boolean = false;

    constructor() {

    }
}
